import { get } from "@insite/client-framework/Services/ApiService";

const currentWebsiteAPIURL = "api/v1/getCurrentWebsiteCountry";

export async function getCurrentWebsiteCountry() {
    const currentWebsiteAPIRes = await (await get<any>(`${currentWebsiteAPIURL}`));
    return currentWebsiteAPIRes;
}